import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ICategorySFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import useGetSelectOption from 'src/hooks/useGetSelectOption';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: ICategorySFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  // 번역
  const { t } = useTranslation();
  // Form
  const methods = useForm<ICategorySFilter>({});
  // 사용여부 옵션
  const { getUseYn } = useGetSelectOption();
  const USEYN_OPTIONS = getUseYn();

  // 검색 함수
  const onValid = (data: ICategorySFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true} cols={2}>
        <FormItem>
          <RHFTextField label={t('category.fields.searchText.name')} name="searchText" />
        </FormItem>
        <FormItem>
          <RHFSelect label={t('category.fields.useYn.name')} name="useYn" options={USEYN_OPTIONS} />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
